import { api } from '../../../../app/auth/apiSlice';

export interface FooterImage {
  id?: number | string | undefined;
  count: number;
  next?: null;
  previous?: null;
  results: FooterImageData[];
}

export interface FooterImageData {
  id?: number | string | undefined;
  alt_text?: string;
  image: string;
  version: string;
}

const footerImageApi = api
  .enhanceEndpoints({ addTagTypes: ['FooterImage'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getFooterImage: builder.query<FooterImageData, void>({
        query: () => {
          return `v1/web-contents/footer/image/`;
        },
        providesTags: ['FooterImage'],
      }),
      addFooterImage: builder.mutation({
        query: (newFooterImage) => ({
          url: 'v1/web-contents/footer/image/',
          method: 'POST',
          body: newFooterImage,
        }),
        invalidatesTags: ['FooterImage'],
      }),
    }),
  });

export const { useGetFooterImageQuery, useAddFooterImageMutation } =
  footerImageApi;
